import type { ReportData } from "../types.js";

/**
 * Generate a JSON report with pretty formatting.
 */
export function generateJsonReport(data: ReportData): string {
  return JSON.stringify(data, null, 2);
}
